<template>
    <div class="cert">
        <div class="title">购买证书</div>
        <div class="table">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="norm" label="规格">
                </el-table-column>
                <el-table-column prop="time" label="付款时间">
                </el-table-column>
                <el-table-column prop="moeny" label="付款金额(元)">
                </el-table-column>
                <el-table-column prop="way" label="支付方式">
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                tableData: [
                    // {
                    //   norm:'10',
                    //   time:'2021-02-28 15:06',
                    //   moeny:'100',
                    //   way:'支付宝'
                    // },
                    // {
                    //   norm:'10',
                    //   time:'2021-02-28 15:06',
                    //   moeny:'100',
                    //   way:'企业支付宝'
                    // },
                ]
            }
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    #userDialog /deep/ .el-dialog--center .el-dialog__body {
        padding-top: 0;
    }

    #userDialog /deep/ .el-dialog--center {
        border-radius: 30px;
    }

    #userDialog /deep/ .el-dialog__header {
        padding: 0;
        width: @a;
        height: 100px;
    }

    #userDialog /deep/ .el-dialog__title {
        width: @a;
        height: 100px;
        text-align: center;
        font-family: MicrosoftYaHei-Bold;
        font-size: 36px !important;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 2px;
        color: #333333 !important;
        line-height: 100px;
    }

    #userDialog .dialogUser {
        width: @a;
        height: 60px;
        margin-top: 30px;

        /deep/ .el-input__inner {
            width: @a;
            height: 60px;
        }
    }

    #userDialog .dialogEmPh {
        width: @a;
        height: 60px;

        /deep/ .el-input__inner {
            width: @a;
            height: 60px;

        }
    }

    #userDialog .dialog_btn {
        width: @a;
        height: 80px;
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        letter-spacing: 1px;
        color: #fff;
        line-height: 80px;
        text-align: center;
        margin-top: 30px;
        cursor: pointer;

    }

    /deep/ .el-table__body tr:hover > td {
        background-image: linear-gradient(#1e6eee 0%, #109ee7 50%, #01cee0 100%);
        color: #fff;
    }

    /deep/ .el-table {
        /deep/ .el-input__inner {
            width: 120px;
            height: 30px;
            margin-left: 15px;
        }

        /deep/ .el-input__icon {
            line-height: 30px;
        }

        /deep/ td {
            font-size: 18px;
            color: #333333;
            letter-spacing: 1px;

            /deep/ .cell {
                @row();
                height: 60px;
            }
        }

        /deep/ th {
            height: 80px;
            background-color: #f5f5f5;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
            // @row();
            padding: 0 !important;

            /deep/ .cell {
                text-align: center;
                overflow: initial;
                @row();
                height: 80px;
            }
        }
    }

    .cert {
        width: @a;
        height: auto;
        margin-left: 4%;

        .title {
            width: @a;
            height: 24px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
        }

        .table {
            width: @a;
            height: auto;
            margin-top: 38px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/certificate/certList.vue